import styled from "styled-components";
import { black, white } from "../styles/colors";
import { ScrollReveal } from "./ScrollReveal";

export function StoryStrip() {
  return (
    <Section id="story">
      <Inner>
        <ScrollReveal>
          <Problem>
            Most goals fade because progress is invisible. You put in the work,
            but the small wins disappear — and motivation goes with them.
          </Problem>
        </ScrollReveal>
        <ScrollReveal delay={1}>
          <Solution>
            Progress makes every day visible. One short video at a time, you
            build a living record of who you&apos;re becoming.
          </Solution>
        </ScrollReveal>
      </Inner>
    </Section>
  );
}

const Section = styled.section({
  padding: "72px 24px",
  background: black,
  color: white,
});

const Inner = styled.div({
  maxWidth: 900,
  margin: "0 auto",
  display: "grid",
  gap: 28,
  textAlign: "center",
});

const Problem = styled.p({
  margin: 0,
  fontSize: "clamp(22px, 3vw, 28px)",
  lineHeight: 1.6,
  color: "rgba(253, 253, 253, 0.55)",
  fontWeight: 400,
});

const Solution = styled.p({
  margin: 0,
  fontSize: "clamp(24px, 3.4vw, 34px)",
  lineHeight: 1.45,
  fontWeight: 700,
  letterSpacing: "-0.02em",
});
